import Html from "@core/libs/html";
import RateLimiter from '@core/libs/rate_limiter';

class ProgressBar {
    constructor(
        private html: Html,
        private rateLimiter: RateLimiter
    ) { }

    init(): void {
        const progressElement = this.html.q('.article-progressbar span');
        const mainProgressElement = this.html.q('.article-progressbar');
        const endElement = this.html.q('#article-end');

        if ( !progressElement || !mainProgressElement || !endElement ) {
            return;
        }


        const onScroll = this.rateLimiter.throttle(() => {
            const totalHeight = endElement.getBoundingClientRect().bottom + window.pageYOffset - window.innerHeight;
            
            const progress = Math.max(0, Math.min(100, (window.pageYOffset / totalHeight) * 100));

            progressElement.style.width = progress + '%';
            mainProgressElement.style.display = progress >= 100 ? 'none' : '';
        }, 25);

        window.addEventListener('scroll', onScroll);
        onScroll();
    }
}

export default ProgressBar;